export const HEAP_APP_ID = process.env.HEAP_ID
export const GTM_CONTAINER_ID = 'GTM-KQMLVD6'

export const DATA_DOG_CLIENT_TOKEN = 'pubc29f5ea862271dcabf6073823cea2714'
export const DATA_DOG_RUM_APPLICATION_ID = 'a8aaa0e5-e4df-4416-89e0-babb5484451d'
export const DATA_DOG_RUM_SAMPLE_RATE = 10
export const DATA_DOG_LOGS_SAMPLE_RATE = 100
